
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.5 44C35.27 44 44 35.27 44 24.5S35.27 5 24.5 5 5 13.73 5 24.5 13.73 44 24.5 44Zm0-8.03c6.335 0 11.47-5.135 11.47-11.47 0-6.335-5.135-11.47-11.47-11.47-6.335 0-11.47 5.135-11.47 11.47 0 6.335 5.135 11.47 11.47 11.47Z","fill":"#D0EFEC"}}),_c('g',{staticClass:"i-Group 7",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Union",attrs:{"d":"m24.25 24.461 2.348-11.117c.498-2.289 1.183-4.115 2.862-5.648 3.635-3.32 9.259-3.08 12.56.536 3.303 3.616 3.033 9.238-.602 12.558-1.678 1.533-3.56 2.05-5.884 2.34l-7.472.766"}}),_c('path',{staticClass:"i-Union_2",attrs:{"d":"m24.25 24.461-1.173 5.559-1.174 5.558c-.499 2.289-1.184 4.115-2.863 5.648-3.635 3.32-9.258 3.08-12.56-.536-3.303-3.616-3.033-9.238.602-12.558 1.679-1.533 3.56-2.05 5.884-2.34l7.472-.723"}})])])
          )
        }
      }
    